export function getStockTypeLabel(typeId, labels) {
  switch (parseInt(typeId)) {
    case 1:
    case 4:
      return labels.stocksAndEtfs || labels.equities;
    case 2: return labels.bonds;
    case 3: return labels.bonds;
    case 5: return labels.reits;
    default: return labels.other || labels.unknown || "Unknown";
  }
}
